<template>
  <div>
    <div v-for="(item, i) in PROF_LICENSE_DETAILS" :key="i" class="border p-2 mb-3 mt-2 baseContentFont mx-1">
      <div>
        <b-row class="px-1">
        <b-col><b>License Type: </b>{{ item.licenseType }}</b-col>
        <b-col><b>License Number: </b>{{ item.licenseNumber }}</b-col>
        <b-col><b>TaxID: </b>{{ item.taxId }}</b-col>
      </b-row>
      <b-row class="px-1">
        <b-col><b>Gender: </b>{{ item.gender }}</b-col>
        <b-col><b>SSN: </b>{{ item.ssn }}</b-col>
        <b-col><b>Date of Birth (DOB): </b>{{ item.dob }}</b-col>
      </b-row>
      <b-row class="px-1">
        <b-col><b>Issued Date: </b>{{ item.issuedDate }}</b-col>
        <b-col><b>Expiration Date: </b>{{ item.expirationDate }}</b-col>
        <b-col><b>Last Renewal Date: </b>{{ item.lastRenewalDate }}</b-col>
      </b-row>
      <b-row class="px-1">
        <b-col><b>Provider Number: </b>{{ item.providerNumber }}</b-col>
        <b-col><b>Sanction Number: </b>{{ item.sanctionNumber }}</b-col>
        <b-col><b>Date Last Seen: </b>{{ item.dateLastSeen }}</b-col>
      </b-row>
      </div>
      <div class="pt-3">
        <b-row class="px-1">
        <b-col><b>Profession or Board: </b>{{ item.profOrBoard }}</b-col>
        <b-col><b>Status: </b>{{ item.status }}</b-col>
        <b-col><b>Effective Date: </b>{{ item.effectiveDate }}</b-col>
      </b-row>
      <b-row class="px-1">
        <b-col><b>Original Name: </b>{{ item.originalName }}</b-col>
        <b-col><b>Email: </b>{{ item.email }}</b-col>
        <b-col><b>Additional Original Name: </b>{{ item.additionalOriginalName }}</b-col>
      </b-row>
      </div>
      <div class="pt-3">
        <b-row class="px-1">
          <b-col><b>Licensed By: </b>{{ item.licenseObtainedBy }}</b-col>
          <b-col><b>Source State: </b>{{ item.sourceState }}</b-col>
          <b-col><b>Occupation: </b>{{ item.occupation }}</b-col>
        </b-row>
      </div>
      <div class="pt-3">
        <b-row class="px-1">
          <b-col md="4"><b>Company Name: </b>{{ item.companyName }}</b-col>
          <b-col md="4"><b>Phone Number: </b>{{ item.phoneNumber }}</b-col>
        </b-row>
        <b-row class="px-1">
          <b-col><b>Address: </b>{{ item.address }}</b-col>
        </b-row>
      </div>
      <div class="pt-3">
        <b-row class="px-1">
          <b-col><b>Board Action Indicator: </b>{{ item.boardActionIndicator }}</b-col>
          <b-col><b>Status: </b>{{ item.boardStatus }}</b-col>
          <b-col><b>Type: </b>{{ item.type }}</b-col>
        </b-row>
        <b-row class="px-1">
          <b-col><b>Violation Description: </b>{{ item.violationDesc }}</b-col>
          <b-col><b>Violation Date: </b>{{ item.violationDate }}</b-col>
          <b-col><b>Effective Date: </b>{{ item.boardEffectiveDate }}</b-col>
        </b-row>
        <b-row class="px-1">
          <b-col><b>Case Number: </b>{{ item.caseNumber }}</b-col>
          <b-col><b>Description: </b>{{ item.description }}</b-col>
          <b-col><b>Posting Date: </b>{{ item.postingDate }}</b-col>
        </b-row>
      </div>
      <div class="pt-2 px-1">
        <BaseELabel :label="`Education (${isListEmpty(item.profLicenseEducation).length})`" class="mb-2" new-style />
        <b-table
          :items="item.profLicenseEducation"
          :fields="educationFields"
          hover
          bordered
          responsive
          striped
          class="mb-0 fraudReportHeaderTable">
        </b-table>
        <NoRecordFound v-if="!isListEmpty(item.profLicenseEducation).length"></NoRecordFound>
      </div>
    </div>
    <NoRecordFound v-if="!isListEmpty(PROF_LICENSE_DETAILS).length" class="mt-1 mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    licensesDetails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      educationFields: [
        {
          key: 'school',
          label: 'School',
          thStyle: { width: '30%' }
        },
        {
          key: 'degree',
          label: 'Degree',
          thStyle: { width: '40%' }
        },
        {
          key: 'datesAttended',
          label: 'Dates Attended',
          thStyle: { width: '30%' }
        },
      ],
    }
  },
  computed: {
    PROF_LICENSE_DETAILS() {
      return this.licensesDetails || []
    },
  },
  methods: {
    // formatSSN(value) {
    //   return value ? value.trim() ? 'XXX-XX-'+ value.substring(7) : '' : ''
    // },
    isListEmpty(list) {
      // to handle empty list when sent as null or [] from API
      return list ? (list.length ? list || [] : []) : []
    },
  },
}
</script>